"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lunr_1 = __importStar(require("lunr"));

var lodash_1 = require("lodash");
/**
 * Wrapper class for Lunr static site search engine.
 */


var LunrSearch =
/** @class */
function () {
  function LunrSearch() {
    var _this = this;

    this.loadIndex = function (index) {
      _this.index = lunr_1.default.Index.load(index);
    };

    this.loadPreviews = function (previews) {
      _this.previews = previews;
    };

    this.search = function (queryString) {
      if (!_this.index) {
        console.log('No search index is available.');
        return [];
      }

      if (!_this.previews) {
        throw new Error('There are no previews to display');
      }

      var previews = _this.previews;

      var results = _this.index.search(queryString).map(function (result, i) {
        return {
          id: i,
          ref: result.ref,
          link: "/" + previews[result.ref].link,
          title: previews[result.ref].title,
          preview: previews[result.ref].body
        };
      });

      return results;
    };

    this.getEngineName = function () {
      return _this.name;
    };

    this.getIndexConfig = function () {
      return _this.indexConfig;
    };

    this.setIndexConfig = function (conf) {
      _this.indexConfig = conf;
    };

    this.addDocuments = function (doc) {
      if (doc instanceof Array) {
        _this.documents = __spreadArrays(doc, _this.documents);
      } else {
        _this.documents.push(doc);
      }
    };
    /**
     * Create Lunr search index object with given configures.
     */


    this.createIndex = function () {
      if (!_this.documents.length) {
        throw new Error('There are no documents to be indexed');
      }

      if (!_this.indexConfig) {
        throw new Error('Index configure must be set before creating index.');
      }
      /**
       * https://lunrjs.com/docs/lunr.Builder.html
       */


      var builder = new lunr_1.Builder(); // Replace non-searchable char with space char, used for tokenize content.

      var filter = function filter(str) {
        return str.replace(/:|\$|#|@|!|\^|\*|\+|-|~|%/gi, ' ');
      }; // Configure index ref and fields


      builder.ref(_this.indexConfig.ref);

      _this.indexConfig.fields.forEach(function (field) {
        builder.field(field.name, field.attributes);
      }); // Add documents to index.


      _this.documents.forEach(function (doc) {
        builder.add({
          id: doc.id,
          title: filter(doc.title),
          body: filter(doc.body),
          link: doc.link
        });
      });

      return builder.build();
    };
    /**
     * Create index preview JSON object.
     */


    this.createPreview = function () {
      var length = Number(process.env.BODILESS_SEARCH_INDEX_PREVIEW_LENGTH) || 100;
      var previews = {};

      _this.documents.forEach(function (doc) {
        var id = doc.id,
            link = doc.link,
            title = doc.title,
            body = doc.body;
        var preview = {
          id: id,
          link: link,
          title: title,
          body: lodash_1.truncate(body, {
            length: length,
            separator: ' '
          })
        };
        previews[id] = preview;
      });

      return previews;
    };
    /**
     * Export serialized index.
     */


    this.exportIndex = function () {
      return JSON.stringify({
        idx: _this.createIndex().toJSON(),
        preview: _this.createPreview()
      });
    };

    this.name = 'Lunr';
    this.documents = [];
    this.indexConfig = null;
    this.index = null;
    this.index = null;
    this.previews = null;
  }

  return LunrSearch;
}();

exports.default = LunrSearch;